import Vue from 'vue';

export default {
  state() {
    return {
      allSchoolList: []
    }
  },
  mutations: {

  },
  getters: {

  },
  actions: {
    /**
     * 查询所有培训机构列表
     * @param {}} context 
     */
    getAllSchoolList(context, state) {
      // console.log('上下文：', context, state)
      Vue.prototype.$api.school.schoolAll({}).then(res => {
        console.log('驾校列表：', res)
        context.state.allSchoolList = res.data;
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/school.js